import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { resolverScreenId } from '../components/layout/screenId';
import { iniciarTelemetria, registrarTela } from '../utils/telemetria';

/**
 * Reporta um page view a cada troca de rota. Montado no `Layout`, que é a
 * layout-route de TODAS as rotas autenticadas — `/login` e `/cot/:token` ficam
 * fora dele por construção, então não há como vazar em rota pública.
 *
 * ⚠ **Dedup por PATHNAME, não por screenId.** O StrictMode remonta o efeito em
 * DEV com o MESMO pathname (é o caso que precisa ser filtrado), mas navegar
 * entre duas entidades da MESMA tela (`/conferencia/8412` -> `/conferencia/9000`)
 * são DUAS aberturas e precisam contar 2 — dedupar por screenId subcontava
 * justamente essa navegação.
 */
export function useTelemetriaPageview(): void {
  const { pathname } = useLocation();
  const ultimoPath = useRef<string | null>(null);

  useEffect(() => {
    iniciarTelemetria();
  }, []);

  useEffect(() => {
    const screenId = resolverScreenId(pathname);
    if (!screenId) return;          // rota desconhecida: não inventa chave
    if (ultimoPath.current === pathname) return;  // StrictMode / re-render
    ultimoPath.current = pathname;
    registrarTela(screenId);
  }, [pathname]);
}
